import { Routes, Route, Navigate } from 'react-router-dom'

import type { ReactElement } from 'react'

import FeaturesView from './Features'
import FeaturesGroupView from './FeaturesGroup'
import IapGraph from './Graph'
import InAppsView from './InApps'
import OffersView from './Offers'
import OffersEditorView from './Offers/Editor'
import IapProducts from './Products'
import IapSubscriptions from './Subscriptions'

import { IapContextProvider } from '~/providers/Iap'

const InAppPurchasesRouter = (): ReactElement => {
  return (
    <div className="view-layout in-apps-purchases-router">
      <IapContextProvider>
        <Routes>
          <Route path="offers">
            <Route element={<OffersView />} index />
            <Route element={<OffersEditorView />} path="editor" />
            <Route element={<OffersEditorView />} path="editor/:offerId" />
          </Route>
          <Route path="in-apps">
            <Route element={<InAppsView />} index />
            <Route element={<InAppsView />} path=":appKey/:deviceType/:sku" />
          </Route>
          <Route element={<Navigate replace to="/404" />} path="*" />
        </Routes>
      </IapContextProvider>
      <Routes>
        <Route element={<FeaturesView />} path="features" />
        <Route element={<FeaturesGroupView />} path="feature-groups" />
        <Route element={<IapGraph />} path="graph" />
        <Route element={<IapProducts />} path="products" />
        <Route element={<IapSubscriptions />} path="subscriptions" />
      </Routes>
    </div>
  )
}

export default InAppPurchasesRouter
